export default __webpack_public_path__ + "static/media/define1.5a9d7328.png";